export default "__VITE_ASSET__DR8FxJ4X__"